import React from 'react';
import { FadeIn, CTAButton } from './ui';
export function MechanismSection() {
  return <section className="bg-navy py-20 px-6 md:py-28 text-white" data-id="element-111">
      <div className="max-w-4xl mx-auto text-center" data-id="element-112">
        <FadeIn data-id="element-113">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-8" data-id="element-114">
            La Clave: El Ciclado de Cortisol
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-115">
          <p className="text-xl md:text-2xl font-medium mb-10 text-cream" data-id="element-116">
            La clave no es comer menos, es el Ciclado de Cortisol.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-117">
          <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-118">
            Este método utiliza la nutrición sincrónica para "engañar" al
            cuerpo. Al mover los carbohidratos estratégicamente hacia la noche y
            priorizar grasas nobles por la mañana, le indicamos al sistema
            nervioso que el peligro ha pasado.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-119">
          <div className="bg-white/10 p-8 rounded-2xl backdrop-blur-sm border border-white/20 mb-12" data-id="element-120">
            <p className="text-xl md:text-2xl font-serif text-cream leading-relaxed" data-id="element-121">
              Cuando el cortisol baja, tu cuerpo finalmente recibe el{' '}
              <span className="text-coral font-bold" data-id="element-122">permiso hormonal</span>{' '}
              para soltar la grasa acumulada y usarla como energía.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-123">
          <CTAButton data-id="element-124" />
        </FadeIn>
      </div>
    </section>;
}